export type PartnerSlug = "bundl" | "rmany" | "crm" | "lanby" | "rmaphil";

export const partnerSlugs: PartnerSlug[] = [
  "bundl",
  "rmany",
  "crm",
  "lanby",
  "rmaphil",
];

export interface PartnerMeta {
  name: string;
  email: string;
}

type PartnerMetaBySlug = { [key in PartnerSlug]: PartnerMeta };

export const partnerMetaBySlug: PartnerMetaBySlug = {
  bundl: {
    name: "Bundl",
    email: "bundl@weconceive.com",
  },
  rmany: {
    name: "RMA of New York",
    email: "rma@weconceive.com",
  },
  rmaphil: {
    name: "RMA of Philadelphia",
    email: "ivirma@weconceive.com",
  },
  crm: {
    name: "Center for Reproductive Medicine Orlando",
    email: "crm@weconceive.com",
  },
  lanby: {
    name: "The Lanby",
    email: "lanby@weconceive.com",
  },
};
